import * as R from 'ramda';

/**
 * string|number 형식의 값을 availableField/v3 format으로 변환
 */
const isCustomMetric = R.test(/^custom-metric:\d+/);
export const makeMetricFormat = (v) => {
    return isCustomMetric(v) ? { key: v, isCustom: true } : { key: v };
};
export const isCustomBreakdown = (v) => !isNaN(v);
export const normalizeCustomBreakdown = (v) => Number(v);
export const makeBreakdownFormat = (v) => {
    if (isCustomBreakdown(v)) {
        // 위젯 저장 시 custom breakdown id는 number 타입으로 저장
        // (브레이크다운 패널 v3 API는 key를 string으로 반환하므로,
        //  패널에서 선택한 값이 '123' 같은 string으로 넘어올 수 있음)
        return { key: normalizeCustomBreakdown(v), isCustom: true };
    }
    return { key: v };
};

export const FIELD_KEY = 'key';
export const pluckFieldKey = R.pluck(FIELD_KEY);
